import CompteurShow from "../Property/CompteurShow";
import Text from "../UI/Text";
import styles from "./EdlLastPageForm.module.css";

interface EdlLastPageFormProps {
  propertyId: number;
}

export default function EdlLastPageForm({ propertyId }: EdlLastPageFormProps) {
  return (
    <div className={styles.container}>
      <Text>
        Vous retrouvez ici les derniers relevés de vos compteurs. Vous pouvez
        les modifier ou en ajouter de nouveaux si besoin. Le dernier relevé de
        chaque type de compteur sera indiqué dans l'état des lieux.
      </Text>
      <CompteurShow propId={propertyId} isFolder={false} />
    </div>
  );
}
